import { attachments } from '@shared/api/services';

export const attachmentApi = {
	fetchAll: () => attachments.list(),
	upload: (file) => attachments.upload(file),
	remove: (id) => attachments.remove(id),
};
